import { useContext } from "react";
import { FakeContext } from "../providers";

const useFake = () => {
  const fakeContext = useContext(FakeContext);

  if (!fakeContext) {
    throw new Error("useFake must be used within an FakeProvider");
  }
  return fakeContext;
};

export default useFake;
